<template>
  <!-- 薪酬查看  -->
  <div class="dashboard-container">
    <div class="app-container">
      <el-card shadow="never">
        <el-form class="demo-form-inline" label-position="right" label-width="100px">
          <el-row :gutter="2">
            <el-col :span="6">
              <el-form-item label="教师姓名:">
                <el-input v-model="formState.teacherName" placeholder="请输入教师姓名" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="年:">
                <el-date-picker v-model="formState.salaryYear" type="year" value-format="yyyy" placeholder="选择年">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="月:" class="month_selection_box">
                <el-date-picker v-model="formState.salaryMonth" type="month" format="M月" value-format="MM"
                  popper-class="picker_month_select" placeholder="选择月份">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item>
                <el-button @click="count" icon="el-icon-thumb" size="small" class="btns">一键计算</el-button>
                <el-button @click="seachClear" class="btns" size="small" icon="el-icon-close">清除</el-button>
                <el-button type="primary" @click="seachRest" size="small" class="btns" icon="el-icon-search">搜索</el-button>
                <el-button type="primary" @click="seachRest1" size="small" class="btns" icon="el-icon-search">导出</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-table style="margin-top: 20px;" height="500" :data="salaryList" :stripe="true" border :highlight-current-row="true" :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}">
          <el-table-column prop="salaryMonth" show-overflow-tooltip  label="月份" width="60"></el-table-column>
          <!-- <el-table-column prop="teacherNo"  show-overflow-tooltip label="教师编号"></el-table-column> -->
          <el-table-column prop="teacherName" show-overflow-tooltip  label="教师姓名"></el-table-column>
          <el-table-column prop="basicSalary"  show-overflow-tooltip label="底薪"></el-table-column>
          <el-table-column prop="dutyClassFee"  show-overflow-tooltip label="义务课时费" width="100"></el-table-column>
          <el-table-column prop="monthClassNum"  show-overflow-tooltip label="当月课时数" width="100"></el-table-column>
          <el-table-column prop="monthClassFee"  show-overflow-tooltip label="当月课时费" width="100"></el-table-column>
          <el-table-column prop="isAlreadyRecommenderFee" show-overflow-tooltip label="内推奖励费" width="150"></el-table-column>
          <el-table-column prop="oneClassMoney" show-overflow-tooltip label="单日五节课奖励费" width="150"></el-table-column>
          <el-table-column prop="nightEightMoney" show-overflow-tooltip label="晚8开始的课补贴费" width="150"></el-table-column>
          <!-- <el-table-column prop="feeWayMoneySum" show-overflow-tooltip label="当月课时费+路补奖励" width="180"></el-table-column> -->
          <el-table-column prop="wayMoney" show-overflow-tooltip label="路补奖励" width="100"></el-table-column>
          <el-table-column prop="feeWayMoneySum" show-overflow-tooltip label="当月课时费+路补奖励" width="180"></el-table-column>
          <!-- <el-table-column prop="exceClassNum" label="超出课时数" width="100"></el-table-column>
          <el-table-column prop="extraCalssFee" label="超出课时费" width="100"></el-table-column>
          <el-table-column prop="oneManyClassNum" label="一对多课数" width="100"></el-table-column>
          <el-table-column prop="oneManyClassFee" label="一对多奖励" width="100"></el-table-column>
          <el-table-column prop="exceFiveClassNum" label="本月日超五节课天数" width="160"></el-table-column>
          <el-table-column prop="exceFiveClassFee" label="超出部分奖金" width="120"></el-table-column>
          <el-table-column prop="isAlreadyRecommenderFee" label="内推奖励" width="140"></el-table-column>
          <el-table-column prop="gradeOneManyFee" label="小学生一对多奖励" width="140"></el-table-column>
          <el-table-column prop="vipTotalClassFee" label="会员总课数奖励" width="120"></el-table-column>
          <el-table-column prop="personalSocialSecurity" label="社保补贴" width="100"></el-table-column>
          <el-table-column prop="providentFundSubsidy" label="公积金补贴" width="100"></el-table-column>
          <el-table-column prop="individualIncomeTax" label="个税"></el-table-column>
          <el-table-column prop="boardLodgingExpenses" label="住宿费"></el-table-column>
          <el-table-column prop="boarder" label="伙食费"></el-table-column> -->

          <el-table-column prop="wageShouldPaid" show-overflow-tooltip label="应发工资" width="150">
            <template slot="header">
                 <span>应发工资</span>
                 <el-tooltip popper-class="tooltip" placement="top">
                   <i class="el-icon-question" style="font-size:17px; color: #009bff;"></i>
                    <div slot="content">
                      <div style="margin-bottom: 10px;">应发工资计算方式：</div>
                      <div>课时费＋义务课时费</div>
                   </div>
                 </el-tooltip>
             </template>
          </el-table-column>

          <el-table-column prop="actualPayroll" show-overflow-tooltip label="实发工资" width="150">
             <template slot="header">
                 <span>实发工资</span>
                 <el-tooltip popper-class="tooltip" placement="top">
                   <i class="el-icon-question" style="font-size:17px; color: #009bff;"></i>
                    <div slot="content">
                      <div style="margin-bottom: 10px;">实发工资计算方式：</div>
                      <div>总课时费－义务课时费</div>
                   </div>
                 </el-tooltip>
             </template>
          </el-table-column>

          <!-- <el-table-column prop="total" label="总计"></el-table-column> -->
          <el-table-column label="操作" fixed="right" width="150">
            <template slot-scope="scope">
              <!-- <el-button type="text" @click="editInfo(scope.row)">编辑</el-button> -->
              <!-- <el-button @click="editInfo(scope.row, '查看')" type="text">查看</el-button> -->
              <el-button @click="editInfo1(scope.row)" type="text">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="formState.pageNum" :page-size="formState.pageSize" layout="prev, pager, next,sizes, jumper"
          :total="totalNum">
        </el-pagination>
      </el-card>
      <salary-dialog ref="salaryMoudel" v-if="isShowDialog" :childTeacherId="parentTeacherId" :editOrview="editOrview"
        @isShowBtn="isShowBtn"></salary-dialog>

    </div>



    <el-card v-if="ShowCourseSalesStatisticsDetails" style="position: fixed;width: 100%;top: 70px; height: 100%;left: 0;z-index: 111;">
        <CourseSalesStatisticsDetails :DetailsRow="DetailsRow" :TimeList="TimeList" @handleEmitButs="handleEmitButs"></CourseSalesStatisticsDetails>
    </el-card>



  </div>
</template>
<script>
import apiBaseUrl from "../../../config/api";
import salaryDialog from "./components/salaryEdit.vue"
import CourseSalesStatisticsDetails from "./CourseSalesStatisticsDetails.vue"
import axios from "axios";
import { getListSalary } from "@/api/salaryapi"
export default {
  components: {
    salaryDialog,
    CourseSalesStatisticsDetails,
  },
  data () {
    return {
      isShowDialog: false,
      editOrview: true,
      formState: {
        pageNum: 1,
        pageSize: 10,
        teacherName: "",
        salaryYear: "",
        salaryMonth: "",
      },
      totalNum: 0,
      salaryList: [],
      parentTeacherId: "",
      ShowCourseSalesStatisticsDetails:false,
      TimeList:['2024-12-01','2024-12-31'],
      DetailsRow:{},
    }
  },
  created () {
    this.getList();
  },
  methods: {

    handleEmitButs  (event) {
        this.ShowCourseSalesStatisticsDetails = event
    },

    count () {
      let data = {
        salaryYear: this.formState.salaryYear,
        salaryMonth: this.formState.salaryMonth
      }
      axios
        .post(`${apiBaseUrl}/salary/calculate`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.$message.success(res.data.message)
            this.getList()
          } else {
            this.$message.error(res.data.message)
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getList () {
      // axios
      // .post(`${apiBaseUrl}/salary/getList`,this.formState)
      // .then((res) => {
      //   console.log(res.data.data);
      //   this.salaryList = res.data.data.records
      //   this.totalNum = res.data.data.total
      // })
      // .catch((error) => {
      //   console.error(error);
      // });
      // console.log(getItem("token"));
      getListSalary(this.formState).then((res) => {
        console.log(res);
        this.salaryList = res.data.records
        this.totalNum = res.data.total
        this.formState.pageNum = res.data.current
      })
    },
    seachRest1(){
      let data = {  teacherName: this.formState.teacherName ? this.formState.teacherName : '', salaryYear: this.formState.salaryYear ? this.formState.salaryYear : '',  salaryMonth: this.formState.salaryMonth ? this.formState.salaryMonth : '', }
      axios.post(`${apiBaseUrl}//salary/exportTeacherSalary`, data, { responseType: "blob", headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}}).then(response => {
         if(response.status == 200){
             const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
             const downloadLink = document.createElement("a");
             downloadLink.href = URL.createObjectURL(blob);
             downloadLink.download = "薪酬模板.xlsx";
             downloadLink.click();
             this.$message.success('导出成功')
         }
         else{
            this.$message.error("上传文件类型只能是 .png, .jpg, .pdf 格式!");
         }
      })
    },
    editInfo1(row, val){
        this.DetailsRow = row
        this.ShowCourseSalesStatisticsDetails = true
    },
    editInfo (row, val) {
      // this.isShowDialog = false
      if (val == "查看") {
        this.editOrview = false
      } else {
        this.editOrview = true
      }
      console.log(row);
      this.isShowDialog = true
      this.parentTeacherId = row.id
      // this.$refs.salaryMoudel.openDialogChild()

    },
    seachClear () {
      this.formState = {
        pageNum: 1,
        pageSize: 10,
        teacherName: "",
        salaryYear: "",
        salaryMonth: "",
      }
      this.getList()
    },
    seachRest () {
      console.log(this.formState);
      this.getList()
    },
    handleSizeChange (pageSize) {
      this.formState.pageSize = pageSize;
      this.getList();
    },
    // 进入某一页
    handleCurrentChange (newPage) {
      this.formState.pageNum = newPage;
      this.getList();
    },
    isShowBtn () {
      this.isShowDialog = false
    },
  }

};
</script>

<style scoped>
.el-form--inline .el-form-item {
  display: inline-block;
  margin-right: 7px;
  vertical-align: top;
  margin-bottom: 19px;
}

::v-deep.el-form-item__label {
  text-align: right;
  vertical-align: middle;
  float: left;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  padding: 0 5px 0 0 !important;
  box-sizing: border-box;
}


/* 兼容移动端 */
@media screen and (max-width: 750px) {
  .dashboard-container {
    /* overflow: auto; */
    width: 1430px;
  }

  /* 兼容移动端 */
  #aa>>>.el-dialog {
    width: 70% !important;
  }
}
.btns{
  background-color: #428BCA;
  border-color: #428BCA;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/manager/salary/salaryview.vue